/**
 * 老 `/ai-digital-human/create` → 三条独立线的落点解析(2026-08-07 IA 重构 I1)。
 *
 * ★为什么要留跳板而不是直接删掉老路由:老收藏、群里发过的链接、`/works` 卡片回跳、
 *   声音库「用 TA 出片」、样片墙「一键套用」、爆款页「送去数字人」—— 这些原本全指向
 *   `/create`。删掉就是一堆 404;留一个跳板,它们继续能用。
 *
 * ★2026-08-08 IA 收尾:**站内 11 处入口已全部改成直指三条线**(`grep ai-digital-human/create`
 *   在 src 下只剩本文件的注释、`DhCreateRedirect` 和 App.tsx 的路由声明)。跳板从此只服务
 *   **站外来的老链接**(收藏 / 群消息 / 企微卡片),不再是站内的中转站 —— 但正因为服务的是
 *   站外,它**永远不能删**:那些链接我们既改不了也召不回。
 *
 * ★解析只看**已经存在的**身份信号,不猜:
 *   1. `dhRemake.mode`(详情页「回工作台改这稿」带的)
 *   2. `scenePreset.kind`(卡墙 / 公共形象 / 声音库 / 视频线「送去数字人」带的)
 *   3. `recipe`(样片墙「一键套用」带的 —— 样片用的是预置形象 = 照片资产)
 *   4. `?mode=`(手写深链)
 *   都没有 → 落 talking(真人口播是这条舱的主推,也是老 `/create` 的默认档)。
 */
import { type DhLineKey } from "@/entities/dh-profile/model/dhLines";

import { filmTypeOfMode } from "./dhRemake";

export type { DhLineKey };

const FILM_TO_LINE: Record<string, DhLineKey> = {
  video: "talking",
  photo: "photo",
  tts: "tts",
};

const SCENE_TO_LINE: Record<string, DhLineKey> = {
  dh_talking: "talking",
  dh_from_video: "talking",
  dh_photo: "photo",
  dh_tts: "tts",
};

export function resolveDhLine(state: unknown, modeParam?: string | null): DhLineKey {
  if (state && typeof state === "object") {
    const s = state as Record<string, unknown>;

    const remake = s.dhRemake as { mode?: unknown } | undefined;
    if (remake && typeof remake.mode === "string") {
      const ft = filmTypeOfMode(remake.mode);
      if (ft && FILM_TO_LINE[ft]) return FILM_TO_LINE[ft];
    }

    const preset = s.scenePreset as { kind?: unknown } | undefined;
    if (preset && typeof preset.kind === "string" && SCENE_TO_LINE[preset.kind]) {
      return SCENE_TO_LINE[preset.kind];
    }

    // 样片墙 recipe:avatarId 是预置形象(照片资产)→ 照片线。
    if (s.recipe && typeof s.recipe === "object") return "photo";
  }

  if (modeParam) {
    const ft = filmTypeOfMode(modeParam);
    if (ft && FILM_TO_LINE[ft]) return FILM_TO_LINE[ft];
    if (FILM_TO_LINE[modeParam]) return FILM_TO_LINE[modeParam];
  }

  return "talking";
}
